import React from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';

interface IARButtonQuitProps {}

const ARButtonQuit = ({}: IARButtonQuitProps) => {
  return (
    <button type="button" className="pt-24 pl-4 transition duration-300 active:scale-90" onClick={() => location.reload()}>
      <div className="bg-white w-14 h-10 rounded-xl flex justify-center items-center">
        <XMarkIcon className="size-8 text-slate-600" />
      </div>
    </button>
  );
};

export default React.memo(ARButtonQuit);
